// extracted by mini-css-extract-plugin
export var numpadContainer = "_lg-1";
export var phoneButton = "_lg-0";